<template>
  <crud-form
    v-model="payload"
    :page-title="$t('app.holidays.add')"
    :request-class="requestClass"
    :total-group="1"
    navigate-back-route="Holidays"
    navigate-page-after-save="Holidays"
  >
    <template slot="group-1">
      <form-group :title="$t('app.holidays.form.subtitle')">
        <v-layout
          class="justify-end"
          wrap
        >
          <v-flex
            xs12
            md4
          >
            <date-picker
              id="dateField"
              v-model="payload.data"
              required
              :label="$t('app.holidays.form.date')"
            />
          </v-flex>
          <v-flex
            xs12
            md10
          >
            <input-text-area
              id="descriptionField"
              v-model="payload.descricao"
              required
              :rules="[maxLength(120)]"
              :label="$t('app.holidays.form.description')"
              :counter="'120'"
            />
          </v-flex>
        </v-layout>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import FormGroup from 'Support/layout/FormGroup.vue';
import HolidaysRequest from 'Domain/holidays/HolidaysRequest';
import CrudForm from 'Support/components/crud/CrudForm.vue';
import RulesMixin from 'Support/mixins/rules-mixin';
import InputTextArea from 'Support/components/inputs/InputTextArea.vue';
import DatePicker from 'Support/components/pickers/DatePicker.vue';

export default {
  name: 'HolidaysForm',
  components: {
    CrudForm,
    FormGroup,
    InputTextArea,
    DatePicker,
  },
  mixins: [RulesMixin],
  data: () => ({
    requestClass: HolidaysRequest,
    payload: {
      data: '',
      descricao: '',
    },
  }),
};
</script>
